// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pen-fluorescence"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M5.86288 14.9653L8.69113 17.7932L7.24215 19.2422L4.41373 19.2422L2.99951 17.828L5.86288 14.9653Z"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M13.044 5.05713L4.5 13.6018L10.0002 19.1021L18.5442 10.5575L13.044 5.05713Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5.86288 14.9653L8.69113 17.7932L7.24215 19.2422L4.41373 19.2422L2.99951 17.828L5.86288 14.9653Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13.044 5.05701L4.5 13.6016L10.0002 19.102L18.5442 10.5574M13.044 5.05701L18.5442 10.5574M13.044 5.05701L16.1007 2L21.601 7.50036L18.5442 10.5574","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PenFluorescenceIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen-fluorescence',
    ref,
    icon: element,
  },
));

PenFluorescenceIcon.displayName = 'PenFluorescenceIcon';

export default PenFluorescenceIcon;
